module.exports = __webpack_public_path__ + "62eb834bcdf1681d8c6d36ef87be69aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/computer.png
// module id = wvnf
// module chunks = 0